import React from 'react';
import { FaTimes } from 'react-icons/fa';
import { Input } from '@Components';
import './text-filter.scss';

type TextFilterProps = {
    value: string;
    setValue: (value: string) => void;
};

export class TextFilter extends React.Component<TextFilterProps> {
    render() {
        const { value, setValue } = this.props;

        return (
            <div className="text-filter">
                <Input
                    type="text"
                    placeholder="Search"
                    value={value}
                    onChange={e => setValue(e.target.value || '')}
                />
                {!!value && <FaTimes className="clear-input-icon" onClick={() => setValue('')} />}
            </div>
        );
    }
}